import React, { Component } from 'react'
import axios from 'axios'
import { Redirect } from 'react-router-dom'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'

export const UserDataContext = React.createContext({
    authToken: null,
    permissions: null,
    userData: null,
    setAuthToken: () => {},
    impersonatedOrganization: null,
    impersonatedUser: null,
})

export default function withAuth(ComponentToProtect) {
    return class extends Component {
        constructor(props, context) {
            super(props, context)
            this.adminOrganization = getEnvVariableValue(VARIABLES.ADMIN_ORG_ID)
            this.state = {
                loading: true,
                authorized: true,
                userData: {
                    authToken: null,
                    permissions: null,
                    data: null,
                    impersonatedOrganization: null,
                    impersonatedUser: null,
                    setData: userData => {
                        this.setState(
                            {
                                userData: {
                                    ...this.state.userData,
                                    ...userData,
                                    isCustomer: this.checkCustomer(userData),
                                },
                            },
                            () => {
                                axios.defaults.headers.common.Authorization =
                                    this.state.userData.authToken
                            }
                        )
                    },
                    setPermissions: permissions => {
                        this.setState({
                            userData: { ...this.state.userData, permissions },
                        })
                    },
                    setAuthToken: authToken => {
                        this.setState(
                            { userData: { ...this.state.userData, authToken } },
                            () => {
                                axios.defaults.headers.common.Authorization =
                                    this.state.userData.authToken
                            }
                        )
                    },
                    setImpersonatedOrganization: (
                        authToken,
                        impersonatedOrganization,
                        permissions
                    ) => {
                        this.state.userData.setData({
                            authToken,
                            impersonatedOrganization,
                            permissions,
                        })
                    },
                    setImpersonatedUser: (
                        authToken,
                        impersonatedUser,
                        data,
                        impersonatedOrganization,
                        permissions
                    ) => {
                        this.state.userData.setData({
                            authToken,
                            impersonatedUser,
                            data,
                            impersonatedOrganization,
                            permissions,
                        })
                    },
                },
            }
        }

        componentDidMount() {
            const { authToken, setPermissions, setAuthToken, setData } =
                this.state.userData
            if (authToken) {
                if (this.state.loading) {
                    this.setState({ loading: false })
                }
                return
            }

            axios
                .get('/_sso-login')
                .then(res => {
                    const { token } = res.data
                    if (!token) {
                        window.location.href = '/_sso-login'
                        return
                    }

                    if (
                        res.data.permissions &&
                        res.data.permissions.length !== 0
                    ) {
                        setPermissions(res.data.permissions)
                    } else {
                        this.setState({ loading: false, authorized: false })
                        return
                    }

                    setAuthToken(res.data.token)

                    if (res.data.user) {
                        const {
                            firstName,
                            lastName,
                            email,
                            username,
                            is_global_admin,
                            is_local_user,
                            organization_id,
                        } = res.data.user
                        setData({
                            data: {
                                firstName,
                                lastName,
                                email,
                                username,
                                is_global_admin,
                                is_local_user,
                                organization_id,
                            },
                        })
                        this.setState({ loading: false })
                    }
                })
                .catch(_ => {
                    this.setState({ loading: false, authorized: false })
                })
        }

        /**
         * Determine if a user is a customer or not.
         * @param userData
         * @returns {boolean}
         */
        checkCustomer(userData) {
            if (userData.data) {
                return userData.data.organization_id !== this.adminOrganization
            }
            if (userData.impersonatedOrganization) {
                return (
                    userData.impersonatedOrganization.organization_id !==
                    this.adminOrganization
                )
            }
        }

        render() {
            const { loading, authorized } = this.state
            if (loading) {
                return null
            }
            if (!authorized) {
                return <Redirect to={'/unauthorized'} />
            }

            return (
                <UserDataContext.Provider value={this.state.userData}>
                    <ComponentToProtect {...this.props} />
                </UserDataContext.Provider>
            )
        }
    }
}
